import styled from "styled-components";
import PaginatedTable from "../../Componentes/Utils/PaginatedTable";
import { useEffect, useState } from "react";
import useApi from "../../hooks/useApi";
import { formatCurrency } from "../../Funcoes/formatCurrency";

import { useModal } from "../../contexts/ModalContext";
import ModalFiltersControladoria from "./ModalFiltersControladoria";
import ModalItensPedidoFrota from "./ModalItensPedidoFrota";
import { formatNumber } from "../../Funcoes/formatNumber";
import { useToast } from "../../contexts/ToastContext";
import { useRegisterControladoriaPageActions } from "./layout";

const API_URL = "Painel/API/Controladoria/PedidosCompra/PedidoFrota/index.php";

const Container = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
`
const BodyWrapper = styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 15px;
    box-sizing: border-box;
`
const StatisticsWrapper = styled.div`
    width: 100%;
    height: 80px;
    display: flex;
    gap: 5px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1.2px solid var(--ctrl-border, #d3d3d3);
    background-color: var(--ctrl-surface-muted, #f0f0f0);
    padding: 5px;
    box-sizing: border-box;
    justify-content: flex-end;
`
const Card = styled.div`
    height: 100%;
    padding: 0 35px 0 15px;
    border-radius: 13px;
    background-color: var(--ctrl-surface, #fff);
    display: flex;
    flex-direction: column;
`
const CardValue = styled.p`
    font-size: 18px;
    font-weight: bold;
    color: var(--ctrl-text, #333);
    margin: 0;
    margin: auto 0 0 0;
`
const CardLabel = styled.p`
    font-size: 12px;
    color: var(--ctrl-text-muted, #555);
    margin: 0;
    margin: 0 0 auto 0;
`
const Body = styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: var(--ctrl-surface, #fff);
    margin-top: 5px;
    border-radius: 8px;
    border: 1.2px solid var(--ctrl-border, #d3d3d3);
    box-sizing: border-box;
`
const Coluna = styled.td`
    text-align: ${({ align }) => align || 'left'};
`
const LinhaPedido = styled.tr`
    cursor: pointer;

    &:hover {
        background-color: #f0f4fa;
    }
`

const PedidoFrota = () => {

    const api = useApi();
    const { notifyError } = useToast();
    const { isModalOpen, openModal, closeModal } = useModal();

    const [pagina, setPagina] = useState(1);
    const [loading, setLoading] = useState(false);

    const [dados, setDados] = useState([]);
    const [stats, setStats] = useState({
        total_pedidos: 0,
        total_itens: 0,
        total_fornecedores: 0,
        valor_total: 0
    });
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const [pedidoSelecionado, setPedidoSelecionado] = useState(null);

    const [filtros, setFiltros] = useState({
        filial: '',
        numPedido: '',
        dataInicio: '',
        dataFim: ''
    })

    const fetchDados = async (page = pagina, curFiltros = filtros) => {
        setLoading(true);

        try {

            const params = new URLSearchParams();
            params.append('page', page);
            params.append('limit', 50);

            if (curFiltros.filial) params.append('filial', curFiltros.filial);
            if (curFiltros.numPedido) params.append('num_pedido', curFiltros.numPedido);
            if (curFiltros.dataInicio) params.append('data_inicio', curFiltros.dataInicio);
            if (curFiltros.dataFim) params.append('data_fim', curFiltros.dataFim);

            const { data } = await api.get(`${API_URL}?${params.toString()}`);

            setDados(data.data || []);
            setStats(data.stats || {});
            setTotalItems(data.quantidade || 0);
            setTotalPages(data.total_pages || 0);

        } catch (e) {
            notifyError(e?.response?.data?.message || "Erro ao carregar pedidos de frota.");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {

        fetchDados(pagina, filtros);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagina]);

    const [refreshing, setRefreshing] = useState(false);

    const refreshData = async () => {

        if (refreshing) return;

        setRefreshing(true);
        await fetchDados();
        setRefreshing(false);

    }

    const aplicarFiltros = () => {

        setPagina(1);
        fetchDados(1, filtros);
        closeModal('pedido-frota-filtros');

    }

    const limparFiltros = () => {

        const limpos = { filial: '', numPedido: '', dataInicio: '', dataFim: '' };
        setFiltros(limpos);
        setPagina(1);
        fetchDados(1, limpos);
        closeModal('pedido-frota-filtros');

    }

    const OpenFilters = () => {

        openModal('pedido-frota-filtros');

    }

    useRegisterControladoriaPageActions({
        onRefresh: refreshData,
        onFilter: OpenFilters,
        refreshing,
    });

    const abrirDetalhe = (pedido) => {

        setPedidoSelecionado(pedido);
        openModal('pedido-frota-itens');

    }

    const fecharDetalhe = () => {

        closeModal('pedido-frota-itens');
        setPedidoSelecionado(null);

    }

    return (
        <>
            <Container>
                <BodyWrapper>
                    <StatisticsWrapper>
                        <Card>
                            <CardValue>{formatNumber(stats.total_pedidos)}</CardValue>
                            <CardLabel>Total de Pedidos</CardLabel>
                        </Card>
                        <Card>
                            <CardValue>R$ {formatCurrency(stats.valor_total)}</CardValue>
                            <CardLabel>Valor Total</CardLabel>
                        </Card>
                        <Card>
                            <CardValue>{formatNumber(stats.total_itens)}</CardValue>
                            <CardLabel>Itens</CardLabel>
                        </Card>
                        <Card>
                            <CardValue>{formatNumber(stats.total_fornecedores)}</CardValue>
                            <CardLabel>Fornecedores</CardLabel>
                        </Card>
                    </StatisticsWrapper>
                    <Body>
                        <PaginatedTable
                            pagina={pagina}
                            setPagina={setPagina}
                            loading={loading}
                            colunas={9}
                            totalItems={totalItems}
                            totalPages={totalPages}
                            mobileCards={dados.map((item) => ({
                                key: `${item.FILIAL}-${item.NUM_PEDIDO}`,
                                title: `Pedido ${item.NUM_PEDIDO} · ${item.PLACA || "Sem placa"}`,
                                meta: `${item.DT_EMISSAO || "—"} · Filial ${item.FILIAL || "—"} · ${
                                    item.FORNECEDOR || "Sem fornecedor"
                                } · R$ ${formatCurrency(item.VALOR_TOTAL)}`,
                                onClick: () => abrirDetalhe(item),
                            }))}
                            thead={
                                <tr>
                                    <th>PEDIDO</th>
                                    <th>FILIAL</th>
                                    <th>EMISSÃO</th>
                                    <th>GRUPO</th>
                                    <th>PLACA</th>
                                    <th>DESCRIÇÃO PLACA</th>
                                    <th>OBSERVAÇÃO</th>
                                    <th>FORNECEDOR</th>
                                    <th>VALOR TOTAL</th>
                                </tr>
                            }
                        >
                            <tbody>
                                {
                                    dados.map(item => (
                                        <LinhaPedido
                                            key={`${item.FILIAL}-${item.NUM_PEDIDO}`}
                                            onClick={() => abrirDetalhe(item)}
                                        >
                                            <td>{item.NUM_PEDIDO}</td>
                                            <td>{item.FILIAL || ' - '}</td>
                                            <td>{item.DT_EMISSAO || ' - '}</td>
                                            <td>{item.GRUPO || ' - '}</td>
                                            <td>{item.PLACA || ' - '}</td>
                                            <td>{item.DESC_PLACA || ' - '}</td>
                                            <td>{item.OBS || ' - '}</td>
                                            <td>{item.FORNECEDOR || ' - '}</td>
                                            <Coluna align="right">{"R$ " + formatCurrency(item.VALOR_TOTAL)}</Coluna>
                                        </LinhaPedido>
                                    ))
                                }
                            </tbody>
                        </PaginatedTable>
                    </Body>
                </BodyWrapper>
            </Container>
            {
                isModalOpen('pedido-frota-filtros') && (
                    <ModalFiltersControladoria
                        fecharModal={closeModal}
                        filtros={filtros}
                        setFiltros={setFiltros}
                        aplicarFiltros={aplicarFiltros}
                        removerFiltros={limparFiltros}
                        clearLabel="Limpar filtros"
                        fields={[
                            { name: "filial", label: "Filial:", type: "text", placeholder: "Ex: 01" },
                            { name: "numPedido", label: "Número do pedido:", type: "text", placeholder: "Filtrar por pedido...", id: "num-pedido" },
                            { name: "dataInicio", label: "Data Inicial:", type: "date", id: "data-inicial" },
                            { name: "dataFim", label: "Data Final:", type: "date", id: "data-final" },
                        ]}
                    />
                )
            }
            {
                isModalOpen('pedido-frota-itens') && pedidoSelecionado && (
                    <ModalItensPedidoFrota
                        pedido={pedidoSelecionado}
                        onClose={fecharDetalhe}
                    />
                )
            }
        </>
    )
}

export default PedidoFrota;
